import { formatInput, gql2 } from "@/gql/lib";
import { CountParametersTier1Tier2, AxisType, ActionEnum } from "@/gql/types";

export type TypeSeveritiesItem = {
  id: string;
  name: string;
  code: number;
  high: number;
  medium: number;
  low: number;
  sensitivity: number;
  last_incident: string;
};

export const get_severities_for_info_type_children = gql2<
  string[],
  TypeSeveritiesItem[]
>("risky-event.per_info_type", (ids, { frame, allInfoTypes }) => {
  const q: CountParametersTier1Tier2 = {
    coordinate: {
      x: { type: AxisType.Severity, values: ["1", "2", "3"] },
      y: {
        type: AxisType.ContentLabel,
        values: ids,
      },
      z: frame,
    },
    pageSize: 1000,
    action: ActionEnum.List,
  };
  return {
    query: `{
        tier1count(params:${formatInput(q)}){
          x{value}
          y{value}
          count
          endDate
        }
      }`,
    mapper: (res) => {
      const { tier1count } = res;
      // @ts-ignore
      const indexed_res = tier1count.reduce((acc, val) => {
        const label_id = val.y.value;
        const severity = +val.x.value;
        if (!acc[label_id]) {
          acc[label_id] = {
            counts: [0, 0, 0],
            last_incident: val.endDate,
          };
        }
        acc[label_id][severity - 1] = val.count;
        return acc;
      }, {});
      const seed = ids
        .map((id) => {
          const label = allInfoTypes[id];
          const from_index = indexed_res[label.id];
          return {
            id: label.id,
            name: label.name,
            code: label.code,
            high: from_index && from_index[2] ? from_index[2] : 0,
            medium: from_index && from_index[1] ? from_index[1] : 0,
            low: from_index && from_index[0] ? from_index[0] : 0,
            last_incident: from_index ? from_index.last_incident : "",
            sensitivity: label.sensitivityLevel,
          } as TypeSeveritiesItem;
        })
        .sort((a, b) => {
          if (a.high == 0 && b.high == 0) {
            if (a.medium == 0 && b.medium == 0) {
              return b.low - a.low;
            } else {
              return b.medium - a.medium;
            }
          } else {
            return b.high - a.high;
          }
        });

      return seed;
    },
  };
});
